import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3f690606"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=3f690606&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_css-loader@6.10.0_prettier@2.8.8_vue-template-compiler@2.6.14_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports